import { DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })

export class GlobalService {
    constructor(private _datePipe: DatePipe) { }

    getfullDateTime(date: Date, time: string) {
        if (date != null) {
            return new Date(this._datePipe.transform(date, "yyyy-MM-dd") + ' ' + time);
        }
        return null;
    }

    getCurrentTime() {
        var date = new Date();

        var hh = (date.getHours() < 10 ? '0' : '') + date.getHours();
        var mm = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
        var ss = (date.getSeconds() < 10 ? '0' : '') + date.getSeconds();

        return hh + ":" + mm + ":" + ss;
    }

    convertBase64ToBlob(Base64Image: any) {
        // SPLIT INTO TWO PARTS
        const parts = Base64Image.split(';base64,');
        // HOLD THE CONTENT TYPE
        const imageType = parts[0].split(':')[1];
        // DECODE BASE64 STRING
        const decodedData = window.atob(parts[1]);
        // CREATE UNIT8ARRAY OF SIZE SAME AS ROW DATA LENGTH
        const uInt8Array = new Uint8Array(decodedData.length);
        // INSERT ALL CHARACTER CODE INTO UINT8ARRAY
        for (let i = 0; i < decodedData.length; ++i) {
            uInt8Array[i] = decodedData.charCodeAt(i);
        }
        // RETURN BLOB IMAGE AFTER CONVERSION
        return new Blob([uInt8Array], { type: imageType });
    }
}
